<template>
    <card-skeleton class-name="bg-white hover-card" :loading="loading">
        <v-card-text class="text-size-md text-secondary-light px-0 font-weight-regular">
            <slot />
        </v-card-text>
    </card-skeleton>
</template>

<script setup lang="ts">
import { IEmptyState } from '../types';
import CardSkeleton from './CardSkeleton.vue';

defineProps<IEmptyState>();
</script>
